<template>
  <div class="overflow-hidden">
    <div v-for="i in 7" :key="i">
      <Skeleton style="width: inherit" height="3rem" class="mx-2 my-3" />
    </div>
  </div>
</template>
